import { useSyncExternalStore } from 'react';
import type { BehaviorSubject } from 'rxjs';

/**
 * El tercer argumento (`getServerSnapshot`) es obligatorio en SSR: sin él React tira
 * "Missing getServerSnapshot" al renderizar en Node. El BehaviorSubject ya tiene su valor
 * inicial (el que hidrató el loader), así que sirve el mismo getter.
 */
export function useObservable<T>(obs: BehaviorSubject<T>): T {
  return useSyncExternalStore(
    (cb) => {
      const s = obs.subscribe(cb);
      return () => s.unsubscribe();
    },
    () => obs.value,
    () => obs.value,
  );
}
